import {
  black,
  grey,
  skyblue,
  white,
  gradient,
  whiteBox,
  whiteUnderBox,
  seasons,
  primaryBlue,
  primaryBlueLighter,
  primaryRed,
  green,
  red,
  orange
} from './colors';

export default {
  common: {
    black: black,
    white: white,
    neutral: skyblue,
    primaryBlue: primaryBlue,
    green: green,
    primaryRed: primaryRed,
    red: red,
    orange: orange
  },
  primary: {
    main: '#323c64',
    light: '#c4c6d1',
    dark: '#2f3762'
  },
  secondary: {
    main: '#c83232',
    light: '#ebc1c4',
    dark: '#cb252f'
  },
  pastel: {
    blue: '#7180D0',
    red: '#D07171'
  },
  success: {
    main: '#45B880',
    light: '#F1FAF5',
    dark: '#00783E'
  },
  info: {
    main: '#1070CA',
    light: '#F1FBFC',
    dark: '#007489'
  },
  warning: {
    main: '#FFB822',
    light: '#FDF8F3',
    dark: '#95591E'
  },
  danger: {
    main: '#ED4740',
    light: '#FEF6F6',
    dark: '#BF0E08',
    red: red,
    paleRed: '#D1573C'
  },
  title: {
    primary: grey.main
  },
  text: {
    primary: grey.dark,
    secondary: grey.light,
    lighter: grey.lighter,
    darker: grey.main,
    white: white,
    placeholder: grey.placeholder
  },
  background: {
    default: skyblue,
    dark: grey.light,
    paper: white,
    autumn: seasons.autumn,
    spring: seasons.spring,
    box: whiteBox,
    underBox: whiteUnderBox,
    lightblue: primaryBlueLighter
  },
  border: grey.light,
  divider: grey.light,
  gradient,
  shadows: {
    boxShadow:
      '12px 12px 28px rgba(203, 200, 200, 0.25), -12px -12px 28px rgba(143, 142, 142, 0.12)',
    buttonShadow:
      'inset 0px 4px 4px rgba(255, 255, 255, 0.25), inset 0px 0px 10px rgba(255, 255, 255, 0.25)',
    bannerShadow:
      '0px 0px 24px 0px rgba(255, 255, 255, 0.25) inset, 0px 10px 10px 0px rgba(255, 255, 255, 0.25) inset',
    textShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
    boxInnerShadow:
      'inset 4px 4px 4px rgba(255, 255, 255, 0.25), inset 0px 4px 4px rgba(255, 255, 255, 0.25)',
    boxInnerShadowHover:
      'inset 4px 4px 4px rgba(255, 255, 255, 0.25), inset 0px 60px 60px rgba(255, 255, 255, 0.25)'
  },
  borderRadius: {
    default: '10px',
    large: '15px',
    extraLarge: '24px'
  }
};
